<div class="reports-table-header">
  <div class="actionss">
    <app-scheduled-exports-janus
      [componentId]="id"
      [title]="title"
      [params]="params"
      [currentFilters]="currentFilters"
      [currentColumnOptions]="currentColumnOptions"
      (exportExcel)="onExportExcel()"
      (exportCsv)="onExportCsv()"
    ></app-scheduled-exports-janus>
  </div>
</div>
